import React from "react";
import { Navbar, Button } from "react-bootstrap";
import { func } from "prop-types";
import FontAwesome from "react-fontawesome";
import LogoImage from "resources/images/Criteria-Logo.png";
import LogoImageSmall from "resources/images/CriteriaLogo_Small.png";
import { LogoImgBig, LogoImgSmall } from "../GlobalNavBar/NavbarComponents";

const DynamicReportsNavBar = ({ handleBack, handlePlatformLoginButton }) => (
  <div>
    <Navbar
      variant="dark"
      style={{ backgroundColor: "#001f4e", padding: "16px" }}
      expand="sm"
    >
      <Button variant="link" onClick={handleBack} className="ml-3 mr-auto">
        <LogoImgBig
          src={LogoImage}
          alt="Criteria Logo"
          width="96"
          height="25.5"
        />
        <LogoImgSmall
          src={LogoImageSmall}
          alt="Criteria Logo"
          width="30"
          height="30"
          className="text-center"
        />
      </Button>
      <Button
        onClick={handlePlatformLoginButton}
        className="teaming-button mr-3 mt-1 text-nowrap"
      >
        Login to Criteria{" "}
        <FontAwesome name="external-link" style={{ marginLeft: "5px" }} />
      </Button>
    </Navbar>
  </div>
);

DynamicReportsNavBar.propTypes = {
  handleBack: func.isRequired,
  handlePlatformLoginButton: func.isRequired,
};

export default DynamicReportsNavBar;
